import { EmailTemplateEventEnum } from "helpers/constants";

export const TEMPLATE_TITLE_MAP: Record<EmailTemplateEventEnum, string> = {
  [EmailTemplateEventEnum.BOOKING_CONFIRMATION]: "preview.confirmReservation",
  [EmailTemplateEventEnum.BOOKING_CANCELLATION]: "preview.cancelReservation",
  [EmailTemplateEventEnum.BOOKING_REMINDER]: "preview.rappelReservation",
  [EmailTemplateEventEnum.POST_BOOKING_FEEDBACK]: "preview.demandeReservation",
};
